export * from './auth-actions';
export * from './company-actions';
export * from './vehicle-actions';
export * from './users-actions';
export * from './customers-actions';
export * from './delivery-actions';
export * from './company-registration-request-actions';
export * from './company-website-request-actions';
export * from './donation-actions';
export * from './product-purchase-actions';
export * from './fleet-actions';
export * from './services-actions';
export * from './developer-hub-actions';
export * from './pickup-points-actions';
export * from './parcel-deliveries-actions';

export const headers = (token: string) => ({
    headers: {
        authorization: `Bearer ${token}`
    }
});